module.exports = __webpack_public_path__ + "img/policy-1.425dbcfe.png";